export const HEADER_HEIGHT = '75';
export const FOOTER_HEIGHT = '268.26';

// media queries related to key points in RootPageLayout.tsx
export const mediaQueries = {
  MIN_WIDTH_361: '@media (min-width:361px)',
  MIN_WIDTH_481: '@media (min-width:481px)',
  MIN_WIDTH_601: '@media (min-width:601px)'
};
